<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <div style="width: 96%;margin: 10px auto">
      <el-tree
        :data="typeList"
        :show-checkbox="showCheckbox"
        :default-expand-all="expandAll"
        node-key="id"
        ref="tree"
        highlight-current
        :props="defaultProps">
        <span class="custom-tree-node" slot-scope="{node,data}">
          <span>{{data.name}}</span>
          <span>{{data.code}}</span>
          <span>
            <el-button type="text" size="mini" @click="() => nodeFunction('add',node,data)">
              {{$t('other.bt.add')}}
            </el-button>
            <el-button type="text" size="mini" @click="() => nodeFunction('update',node,data)">
              {{$t('other.bt.edit')}}
            </el-button>
            <el-button type="text" size="mini" @click="() => nodeFunction('delete',node,data)">
              {{$t('other.bt.delete')}}
            </el-button>
          </span>
        </span>
      </el-tree>
    </div>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
    import Qs from 'qs'
    import FORM from '@/components/page/form.vue'
    import UPDATE from '@/components/page/update.vue'
    import Url from "@/views/other/util/url"
    import Util from "@/views/other/util/utils"
    let typeList = {0:"类别",1:"试卷标题"};
    export default {
        name: 'list',
        components: {
            FORM,
            UPDATE
        },
        mounted(){
          this.init();
        },
        methods: {
          init(){
              this.$axios.get(Url.question.type.list).then(res => {
                  if (res.code == 0){
                      this.typeList = Util.buildTreeArr(res.result, "id", "pid", "children");
                  }
              });
          },
          /*查询表单按钮点击事件*/
          formclick(clickName){
              if(window.$t('other.question.addType') == clickName){
                  this.$refs.childUpdate.open();
              }
          },
          nodeFunction (type,node,data){
              let copy = this.common.copy(data);
              copy.children = [];
              if (type == "add"){
                  this.$refs.childUpdate.open({pid:data.id});
              }else if(type == "update"){
                  this.$refs.childUpdate.open(copy);
              }else if(type == "delete"){
                  this.$confirm(window.$t("page.confirm")+ "删除"+ data.name +window.$t("page.opertion"), "删除", {
                      confirmButtonText: window.$t("page.enter"),
                      cancelButtonText: window.$t("page.cancel"),
                      type: 'warning'
                  }).then(() => {
                      this.dataChanage(Url.question.type.delete,{id:copy.id},res => {
                          if (res.code == 0){
                              this.$refs.childUpdate.close();
                              this.$message.success("suc");
                          }else{
                              this.$message.error(res.message);
                          }
                      })
                  });

              }
          },
          submit(model){
              //根据是否包含id更新还是添加
              this.dataChanage(Url.question.type.update,model,res => {
                  if (res.code == 0){
                      this.$refs.childUpdate.close();
                      this.$message.success("suc");
                  }else{
                      this.$message.error(res.message);
                  }
              })
          },
          dataChanage(url,option,suc,fail){
              this.$axios.post(url, Qs.stringify(option || {})).then(res => {
                  this.init();
                  if(suc && (typeof suc == 'function')) suc(res);
              }).catch(res => {
                  if(fail && (typeof fail == 'function')) fail(res);
              })

          },
        },
        data () {
            return {
                typeList:[],
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                expandAll:false,
                showCheckbox:false,
                /*from查询表单*/
                formData:{
                    cols:[
                        {click:window.$t('other.question.addType')},
                    ]
                },
                updateData:{
                    cols:[
                        { title: 'id', field: 'id',hidden:true},
                        { title: 'pid', field: 'pid',hidden:true,data:0},
                        { title: window.$t('other.question.name'), field: 'name',required:true},
                        { title: window.$t('other.question.code'), field: 'code',required:true},
                        { title: window.$t('other.question.type'), field: 'type',type:3,optionList: typeList,isNumber:true,required:true}
                    ]
                },
            }
        }
    }
</script>
